import { UserLocaleCode } from "@/shared/@types/UserLocaleCode";

export const defaultLocale = {
  code: UserLocaleCode.DE,
  name: "Deutsch",
  flag: "flagDe",
} as const;

// order matters here, since it is the order in the language selection drawer
export const availableLocales = [
  defaultLocale,
  {
    code: UserLocaleCode.DE_AT,
    name: "Deutsch (Österreich)",
    flag: "flagAt",
  },
  {
    code: UserLocaleCode.DE_CH,
    name: "Deutsch (Schweiz)",
    flag: "flagCh",
  },
  { code: UserLocaleCode.EN, name: "English", flag: "flagGb" },
  { code: UserLocaleCode.FR, name: "Français", flag: "flagFr" },
  {
    code: UserLocaleCode.FR_BE,
    name: "Français (Belgique)",
    flag: "flagBe",
  },
  {
    code: UserLocaleCode.FR_CH,
    name: "Français (Suisse)",
    flag: "flagCh",
  },
  {
    code: UserLocaleCode.IT_CH,
    name: "Italiano (Svizzera)",
    flag: "flagIt",
  },
  { code: UserLocaleCode.NL, name: "Nederlands", flag: "flagNl" },
  {
    code: UserLocaleCode.NL_BE,
    name: "Nederlands (België)",
    flag: "flagBe",
  },
] as const;
